
// import ReactDOM from 'react-dom/client';

import { renderInto } from '../utils/render';

import {AddToQuote} from "./components/addToQuote";
import {QuoteCount} from "./components/quoteCount";
// import {QuoteRecap} from "./components/quoteRecap";
import {QuoteRecapEstimateShipping} from "./components/quoteRecapEstimateShipping";

import {ConvertToQuote} from "./components/convertToQuote";
// import {quotePageNew} from "./components/quotePageNew";
import {QuotePageAccordion} from "./components/quotePageAccordion";
// import {QuotePageAccordionSectionTest} from "./components/quotePageAccordionSectionTest";
import {QuotePage} from "./components/quotePage";
// import {QuoteFormAccordionOrig} from "./components/quotePageAccordionOrig";
// import {QuotePageAccordionLabels} from "./components/quotePageAccordionLabels";
// import {QuotePageAccordionShipping} from "./components/quotePageAccordionShipping";
// import {QuotePageAccordionInstall} from "./components/quotePageAccordionInstall";



// import { CollectionListTracker } from '../utils/collectionListTracker';

// const tracker = new CollectionListTracker('___ELEVAR_GTM_SUITE--lastCollectionPathname', 'wgCollectionNames');
// tracker.addCollection();



// import {quoteState} from "./components/quoteState";

export const initializeQuote  = () => {
  if (document.querySelector('.header__action-item--quote')) {
    renderInto(document.querySelector('.header__action-item--quote'), QuoteCount);
    // React.createElement(QuoteCount), document.querySelector('.header__action-item--quote');
    // ReactDOM.render(
    //   React.createElement(QuoteCount),
    //   document.querySelector('.header__action-item--quote')
    // );
  };
  
  if (document.getElementById('add_to_quote_button_container')) {
    renderInto(document.getElementById('add_to_quote_button_container'), AddToQuote);
    // React.createElement(AddToQuote), document.getElementById('add_to_quote_button_container');
    // ReactDOM.render(
    //   React.createElement(AddToQuote),
    //   document.getElementById('add_to_quote_button_container')
    // );
  };



  if (document.getElementById('quote-page-accordion')) {
    renderInto(document.getElementById('quote-page-accordion'), QuotePageAccordion);
    // React.createElement(QuotePageAccordion), document.getElementById('quote-page-accordion');
    // ReactDOM.render(
    //   React.createElement(QuotePageAccordion),
    //   document.getElementById('quote-page-accordion')
    // );
  };

  // if (document.getElementById('quote-page-accordion-test')) {
  //   ReactDOM.render(
  //     React.createElement(QuotePageAccordionSectionTest),
  //     document.getElementById('quote-page-accordion-test')
  //   );
  // };


  if (document.getElementById('quote-page-new-test')) {
    renderInto(document.getElementById('quote-page-new-test'), QuotePage);
    // React.createElement(QuotePage), document.getElementById('quote-page-new-test');
    // ReactDOM.render(
    //   React.createElement(QuotePage),
    //   document.getElementById('quote-page-new-test')
    // );
  };



  if (document.getElementById('quote-recap-shipping')) {
    renderInto(document.getElementById('quote-recap-shipping'), QuoteRecapEstimateShipping);
    // React.createElement(QuoteRecapEstimateShipping), document.getElementById('quote-recap-shipping');
    // ReactDOM.render(
    //   React.createElement(QuoteRecapEstimateShipping),
    //   document.getElementById('quote-recap-shipping')
    // );
  };
  if (document.querySelector('.convert_to_quote_button_container')) {
    renderInto(document.querySelector('.convert_to_quote_button_container'), ConvertToQuote);
    // React.createElement(ConvertToQuote), document.getElementById('convert_to_quote_button_container');
    // ReactDOM.render(
    //   React.createElement(ConvertToQuote),
    //   document.querySelector('.convert_to_quote_button_container')
    // );
  };

  // if (document.getElementById('quote-page-accordion-labels')) {
  //   ReactDOM.render(
  //     React.createElement(QuotePageAccordionLabels),
  //     document.getElementById('quote-page-accordion-labels')
  //   );
  // };

  // if (document.getElementById('quote-page-accordion-install')) {
  //   ReactDOM.render(
  //     React.createElement(quotePageAccordionShipping),
  //     document.getElementById('quote-page-accordion-install')
  //   );
  // };

    // if (document.getElementById('quote-page')) {
    //   ReactDOM.render(
    //     React.createElement(quotePageOld),
    //     document.getElementById('quote-page')
    //   );
    // };

    // if (document.getElementById('quote-page-new')) {
    //   ReactDOM.render(
    //     React.createElement(quotePageNew),
    //     document.getElementById('quote-page-new')
    //   );
    // };

  

  

}
